import { forwardRef } from "react";
import { initials, colorFor } from "./helpers";

const W = 900;

export const StandingsExportCard = forwardRef(({ standings }, ref) => {
  const today = new Date().toLocaleDateString("it-IT", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  const medals = ["#F59E0B", "#CBD5E1", "#B45309"];

  return (
    <div
      ref={ref}
      style={{
        position: "fixed",
        left: "-10000px",
        top: 0,
        width: `${W}px`,
        background: "#090D16",
        padding: "40px",
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        boxSizing: "border-box",
      }}
    >
      {/* header */}
      <div style={{ display: "flex", alignItems: "center", gap: "16px", marginBottom: "28px" }}>
        <div
          style={{
            width: "56px", height: "56px", borderRadius: "16px",
            background: "linear-gradient(135deg,#10B981,#047857)",
            display: "flex", alignItems: "center", justifyContent: "center",
            color: "#04120b", fontWeight: 900, fontSize: "28px",
            fontFamily: "'Barlow Condensed', sans-serif",
          }}
        >
          AP
        </div>
        <div style={{ flex: 1 }}>
          <div
            style={{
              fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 900,
              textTransform: "uppercase", fontSize: "34px", color: "#ffffff",
              lineHeight: 1,
            }}
          >
            American Padel 2026
          </div>
          <div style={{ color: "#10B981", fontSize: "14px", letterSpacing: "4px", marginTop: "4px" }}>
            CLASSIFICA GENERALE
          </div>
        </div>
        <div style={{ color: "#64748B", fontSize: "14px", textTransform: "capitalize" }}>{today}</div>
      </div>

      {/* table head */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "52px 1fr 60px 60px 80px 80px",
          padding: "12px 16px",
          background: "#0b1120",
          borderRadius: "12px 12px 0 0",
          color: "#94a3b8",
          fontSize: "13px",
          textTransform: "uppercase",
          letterSpacing: "1px",
          fontFamily: "'JetBrains Mono', monospace",
        }}
      >
        <div style={{ textAlign: "center" }}>#</div>
        <div>Giocatore</div>
        <div style={{ textAlign: "center" }}>V-P</div>
        <div style={{ textAlign: "center" }}>Games</div>
        <div style={{ textAlign: "center" }}>Diff</div>
        <div style={{ textAlign: "center" }}>Punti</div>
      </div>

      {/* rows */}
      {standings.map((p, i) => {
        const c = colorFor(p.player_id);
        return (
          <div
            key={p.player_id}
            style={{
              display: "grid",
              gridTemplateColumns: "52px 1fr 60px 60px 80px 80px",
              alignItems: "center",
              padding: "12px 16px",
              background: i % 2 ? "#0d1526" : "#111a2e",
              borderLeft: `4px solid ${i < 3 ? medals[i] : "transparent"}`,
            }}
          >
            <div
              style={{
                textAlign: "center", fontFamily: "'Barlow Condensed', sans-serif",
                fontWeight: 900, fontSize: "22px", color: i < 3 ? medals[i] : "#cbd5e1",
              }}
            >
              {p.position}
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div
                style={{
                  width: "34px", height: "34px", borderRadius: "50%",
                  background: `linear-gradient(135deg,${c},${c}cc)`,
                  color: "#04120b", fontWeight: 800, fontSize: "14px",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontFamily: "'Barlow Condensed', sans-serif",
                }}
              >
                {initials(p.name)}
              </div>
              <span style={{ color: "#ffffff", fontWeight: 600, fontSize: "17px" }}>{p.name}</span>
            </div>
            <div style={{ textAlign: "center", fontFamily: "'JetBrains Mono', monospace", fontSize: "15px", color: "#cbd5e1" }}>
              {p.wins}-{p.losses}
            </div>
            <div style={{ textAlign: "center", fontFamily: "'JetBrains Mono', monospace", fontSize: "15px", color: "#cbd5e1" }}>
              {p.games_won}-{p.games_lost}
            </div>
            <div
              style={{
                textAlign: "center", fontFamily: "'JetBrains Mono', monospace", fontSize: "15px",
                fontWeight: 700, color: p.games_diff > 0 ? "#10B981" : p.games_diff < 0 ? "#f43f5e" : "#94a3b8",
              }}
            >
              {p.games_diff > 0 ? "+" : ""}{p.games_diff}
            </div>
            <div style={{ textAlign: "center" }}>
              <span
                style={{
                  display: "inline-block", minWidth: "40px", padding: "4px 8px", borderRadius: "8px",
                  background: "rgba(16,185,129,0.15)", color: "#10B981", fontWeight: 900,
                  fontFamily: "'JetBrains Mono', monospace", fontSize: "20px",
                }}
              >
                {p.points}
              </span>
            </div>
          </div>
        );
      })}

      <div
        style={{
          marginTop: "20px", display: "flex", justifyContent: "space-between",
          color: "#64748B", fontSize: "13px",
          fontFamily: "'JetBrains Mono', monospace", letterSpacing: "1px",
        }}
      >
        <span>AMERICANA · STAGIONE 2026</span>
        <span>V2-0=3 · V2-1=2 · P1-2=1 · P0-2=0</span>
      </div>
    </div>
  );
});

StandingsExportCard.displayName = "StandingsExportCard";
